import { useState, useEffect } from 'react';
import PageLayout from '../components/layout/PageLayout';
import { fetchContact } from '../services/contactService';
import { contact as fallbackContact } from '../data/contact';

export default function ContactPage() {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetchContact().then((data) => {
      setContact(data || fallbackContact);
      setLoading(false);
    });
  }, []);

  if (loading) return null;

  const handleCopyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(contact.email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <PageLayout>
      <div className="contact-page">
        <div className="contact-inner">
          <div className="contact-grid">

            {/* Left */}
            <div className="contact-left">
              <h1 className="contact-h1">Let's work together.</h1>
              <p className="contact-intro">{contact.intro}</p>
              <span className="contact-email-wrap">
                <a
                  href={`mailto:${contact.email}`}
                  className="contact-email-btn"
                  onClick={handleCopyEmail}
                >
                  {contact.email}
                </a>
                <span className={`contact-copied-toast${copied ? ' contact-copied-toast--visible' : ''}`}>
                  Copied
                </span>
              </span>
            </div>

            {/* Right */}
            <div className="contact-right">
              <div className="contact-identity">
                <span className="contact-identity-name">{contact.name}</span>
                <span className="contact-identity-title">{contact.title}</span>
              </div>

              <div>
                <span className="contact-section-label">Services</span>
                <ul className="contact-service-list">
                  {(contact.services || []).map((s) => (
                    <li key={s} className="contact-service-item">
                      <span className="contact-service-dash">—</span>
                      {s}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <span className="contact-section-label">Location</span>
                <p style={{ fontSize: '0.875rem', color: 'var(--c-n700)' }}>{contact.location}</p>
              </div>

              <div>
                <span className="contact-section-label">Links</span>
                <div className="contact-links">
                  {(contact.links || []).map((link) => (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      {link.label}
                      <span className="contact-link-arrow">↗</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}
